<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="Account Message" class="chat-layout">
    <template v-slot:body>
      <div class="page-sale-account-message-container">
        <div class="app-inner-layout chat-layout">
          <div class="app-inner-layout__wrapper">
            <div class="app-inner-layout__sidebar card">
              <div class="app-inner-layout__sidebar-header">
                <ul class="nav flex-column">
                  <li class="pt-4 pl-3 pr-3 pb-3 nav-item">
                    <div class="input-group">
                      <input placeholder="Search..." type="text" class="form-control" @keyup.enter="searchAccount()" @change="changeSearchAccount($event.target.value)" />
                      <div class="input-group-append" @click="searchAccount()">
                        <div class="input-group-text">
                          <i class="ti ti-search"></i>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item-header nav-item">Accounts</li>
                </ul>
              </div>
              <div class="app-inner-layout__sidebar-body scrollbar" ref="accountSidebar">
                <div v-if="accounts.length == 0" class="h5 text-center text-secondary">No Account</div>
                <ul v-else class="nav flex-column">
                  <li :class="'nav-item item-' + _account.id" v-for="_account in accounts" :key="_account.id" @click="chooseAccount(_account)">
                    <button type="button" tabindex="0" :class="[_account.id == query.selected.id ? ' active' : '', 'dropdown-item']">
                      <div class="widget-content p-0">
                        <div class="widget-content-wrapper">
                          <div class="widget-content-left mr-3">
                            <div class="avatar-icon-wrapper position-relative">
                              <div v-if="_account.logged" class="badge badge-bottom badge-success badge-dot badge-dot-lg"></div>
                              <div class="avatar-icon">
                                <img :src="noThumbnail" />
                              </div>
                              <div v-if="_account.notification.messages" class="message-count">
                                {{ _account.notification.messages }}
                              </div>
                            </div>
                          </div>
                          <div class="widget-content-left">
                            <div class="widget-heading">{{ _account.text }}</div>
                            <div class="widget-subheading">{{ _account.server }}</div>
                          </div>
                        </div>
                      </div>
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <component v-if="component != ''" :is="component" :config="accountConfig()"></component>
            <template v-else>
              <div class="app-inner-layout__sidebar bg-white card">
                <div class="bg-white">
                  <div class="app-inner-layout__sidebar-body scrollbar">
                    <div class="h5 text-center text-secondary pt-3">No customers</div>
                  </div>
                </div>
              </div>
              <div class="app-inner-layout__content card has-overlay">
                <div class="table-responsive">
                  <div class="app-inner-layout__top-pane">
                    <div class="pane-left">
                      <div class="mobile-app-menu-btn">
                        <button type="button" class="hamburger hamburger--elastic">
                          <span class="hamburger-box"><span class="hamburger-inner"></span></span>
                        </button>
                      </div>
                      <div class="avatar-icon-wrapper mr-2">
                        <div class="avatar-icon avatar-icon-xl rounded">
                          <img width="82" :src="noThumbnail" />
                        </div>
                      </div>
                      <h4 class="mb-0 text-nowrap">No Custommer</h4>
                    </div>
                    <div class="pane-right float-right attachment"></div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
  </Body>
</template>

<script>
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
import Event from '@/helper/event.js'
import shopIcon from '@/../assets/imgs/shop-icon.png'

export default {
  components: {
    Header,
    Body,
    SideBar
  },
  mixins: [Event],
  data() {
    return {
      preload: true,
      component: '',
      noThumbnail: shopIcon,
      query: {
        selected: false,
        page: 1,
        search: '',
        total: false
      },
      accounts: {},
      debounce: {
        onScroll: _.debounce(this.onScroll, 100),
        onResize: _.debounce(this.onResize, 100)
      },
      wsStatus: 'idle',
      wsResult: '',
      wsClient: null
    }
  },
  computed: {
    storeId() {
      return 'main'
    },
    indexUri() {
      return 'account-message'
    }
  },
  mounted() {
    window.addEventListener('resize', this.debounce.onResize)
    this.$refs.accountSidebar.addEventListener('scroll', this.debounce.onScroll)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.debounce.onResize)
    this.$refs.accountSidebar.removeEventListener('scroll', this.debounce.onScroll)
  },
  methods: {
    onScroll() {
      if (this.query.total > 0 || this.query.total === false) {
        let element = this.$refs.accountSidebar
        if (element.scrollHeight - element.scrollTop <= element.clientHeight + 50) {
          this.reloadAccountData()
        }
      }
    },
    onResize() {
      if (this.$refs.accountSidebar) {
        this.$refs.accountSidebar.style.height = window.innerHeight - this.$util.getOffset(this.$refs.accountSidebar).top + 'px'
        if (window.innerHeight == document.body.offsetHeight) {
          return true
        }
      }
      return false
    },
    accountConfig() {
      return {
        query: this.query,
        accounts: this.accounts
      }
    },
    setUpData(rawData, args) {
      if (!_.isArray(rawData.items)) return
      let accounts = Object.values(this.accounts)
      if (parseInt(args.page) < 2) {
        accounts = []
      }

      rawData.items.forEach((items) => {
        items.children.forEach((item) => {
          item.server = items.text
          accounts.push(item)
        })
      })

      this.query = Object.assign(this.query, {
        search: args.search,
        total: rawData.total_items,
        page: parseInt(args.page) > 0 ? parseInt(args.page) : 1
      })

      this.accounts = accounts
    },
    reloadAccountData() {
      this.fetchData(
        {
          page: this.query.page + 1,
          search: this.query.search
        },
        {
          $el: this.$refs.accountSidebar
        }
      )
    },
    changeSearchAccount(search) {
      this.query.search = search
    },
    searchAccount() {
      this.query.page = 0
      this.reloadAccountData()
    },
    chooseAccount(account) {
      this.query.selected = account
      let platform = _.pascalCase(account.platform || '')
      let component = `${platform}.AccountMessage.Index`
      if (this.$options.components[component] == undefined) {
        this.$options.components[component] = this.$util.requireOrNull(`/platforms/${platform}/AccountMessage/Index.vue`)
      }

      if (!_.isUndefined(account.platform) && this.$options.components[component] !== null) {
        this.component = component
      } else {
        this.$util.notify({
          text: 'Platforms not supported!',
          status: 'error'
        })
      }
    },
    async testWebSocket() {
      if (!this.wsClient) {
        this.wsClient = new WebSocketClient()
        this.wsClient.on('connection', (data) => {
          this.wsStatus = data.status
        })
        this.wsClient.on('test-event', (data) => {
          this.wsResult = JSON.stringify(data)
        })
      }
      this.wsStatus = 'connecting...'
      try {
        // Gửi một message test (event: 'test-event', data: {msg: 'hello'})
        const result = await this.wsClient.sendMessage('test-event', { msg: 'hello' }, true)
        this.wsResult = JSON.stringify(result)
      } catch (e) {
        this.wsResult = 'Error: ' + e.message
      }
    }
  },
  created() {
    this.$util.webSocket
  }
}
</script>
<style lang="scss">
.scroll-to-top {
  display: none;
}
.page-sale-account-message-container {
  margin: -30px;
  border-top: 1px solid #e9ecef;
  .app-inner-layout__top-pane {
    .pane-right.attachment {
      > a {
        color: #fff;
        cursor: pointer;
        user-select: none;
      }
    }
  }
  .app-inner-layout__wrapper {
    min-height: 0;
    .app-inner-layout__sidebar.card {
      width: 300px;
      flex: 0 0 300px;
      border-left: 0;
      .displaying-num {
        display: none;
      }
      .tablenav-pages {
        display: flex;
        justify-content: center;
        float: none;
      }
      .dropdown-item {
        min-height: 80px;
        border-bottom: 1px solid #efefef;
      }
      .client-excerpt {
        max-width: 170px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .message-count {
        position: absolute;
        top: -4px;
        right: -4px;
        width: 22px;
        height: 22px;
        background: #c50000;
        border-radius: 50%;
        border: 1px solid #fff;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
      }
      .app-inner-layout__sidebar-body {
        overflow: auto;
        overflow-x: hidden;
        .dropdown-item {
          position: relative;
          &.active {
            .icon-wrapper {
              i {
                color: #fff !important;
              }
            }
          }
        }
        .item {
          &.item-readed,
          &.item-unread {
            > .dropdown-item {
              padding: 0 !important;
              min-height: 0 !important;
              > .widget-content {
                min-height: 80px;
                padding: 0.4rem 1.5rem !important;
                display: flex;
              }
            }
            .dropdown {
              position: absolute;
              right: 0;
              z-index: 999999999;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;
              > div.icon-wrapper {
                width: 28px;
                height: 28px;
                padding: 5px;
              }
              .dropdown-menu {
                left: -15px !important;
              }
              i {
                color: #333;
                font-size: 16px;
              }
              a {
                display: block;
                padding: 10px 20px;
                color: #333;
                &:hover {
                  color: #fff;
                  background-color: #3f6ad8;
                }
              }
            }
          }
        }

        .item.item-readed {
          .widget-content {
            opacity: 0.7;
          }

          /* .fa-fw {
            content: ;
            &:hover {
              content: ;
            }
          } */
        }
        .item.item-unread {
          .dropdown-item {
            background: #c5e3ff;
            border-bottom: 1px solid #2196f3;
          }
          .widget-content {
            opacity: 1;
          }
          .widget-heading {
            opacity: 1;
            font-weight: 500;
          }
          .widget-subheading {
            opacity: 1;
          }
          .dropdown {
            i {
              color: #333;
            }
          }
        }
      }
    }
    .app-inner-layout__content.card {
      &.has-overlay {
        &::before {
          content: '';
          display: block;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 999;
          background: #fff;
          opacity: 0.5;
        }
      }
      .chat-wrapper {
        overflow: auto;
        > div > div {
          clear: both;
          max-width: 90%;
        }
        .chat-box {
          display: block;
        }
        .chat-message {
          flex: 1;
        }
        .message-image-wrapper {
          display: flex;
          order: 0;
          width: 100%;
          margin-bottom: 5px;
          .img-preview {
            width: 80px;
            height: 80px;
            margin-left: 5px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              border: 1px solid #dfdfdf;
              border-radius: var(--border-radius, 0.25rem);
            }
          }
        }
        .float-right .message-image-wrapper {
          justify-content: flex-end;
        }
        .chat-box-wrapper.chat-box-wrapper-right {
          justify-content: flex-end;
          .avatar-icon-wrapper {
            order: 2;
          }
          .chat-message {
            order: 1;
          }
        }
      }
      .input-message {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        z-index: 10;
        background: #fff;
        margin: 10px 0px;
        > div {
          width: 100%;
          padding: 0 20px;
        }
        textarea {
          padding-right: 80px;
          background: #f5f5f5;
          border: 0;
          border-radius: var(--border-radius, 0.25rem);
          flex: 1;
          font-size: 14px;
        }
        .submit {
          position: absolute;
          cursor: pointer;
          top: calc(50% - 10px);
          right: 35px;
          fill: #ccc;
          z-index: 9;
          top: 0;
          height: 40px;
          &:hover {
            fill: #3f6ad8;
          }
        }
        .image-message {
          background: #f5f5f5;
          padding: 5px 15px;
          margin-bottom: 5px;
          display: inline-block;
          border-radius: 100px;
          max-width: 100%;
          cursor: pointer;
          user-select: none;
          span {
            white-space: nowrap;
            overflow: hidden;
            display: block;
          }
        }
        .add-images {
          position: absolute;
          width: 40px;
          height: 36px;
          right: 56px;
          cursor: pointer;
          top: 0;
          margin: 0 0;
          display: flex;
          align-items: center;
          justify-content: center;
          .background-svg {
            fill: #ccc;
          }
          .border-svg {
            stroke: #ccc;
          }
          &:hover {
            .background-svg {
              fill: #3f6ad8;
            }
            .border-svg {
              stroke: #3f6ad8;
            }
          }
        }
      }
    }
  }
}
</style>
